import React from 'react';
import Modal from './Modal';
import ContactForm from './ContactForm';

// Brand-styled contact modal opened from the global floating "Contact" button.
// (Distinct from the semantic-ui ContactModal used inside Home/HomeValuation/etc.)
function FloatingContactModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} labelledBy="floating-contact-title" wide>
      <p className="app-modal-eyebrow">Get In Touch</p>
      <h2 id="floating-contact-title" className="app-modal-title">Let's Connect</h2>
      <p className="app-modal-sub">
        Whether you're buying, selling, or just exploring, I'd love to hear from you.
      </p>
      <ContactForm animateIn={false} />
    </Modal>
  );
}

export default FloatingContactModal;
